import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img
              src="/assets/images/header.png"
              alt="Logo"
              className="h-8 w-auto"
            />
            <span className="text-lg font-semibold text-brand-text">
              嘉屹工作室
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("hero")}
              className="text-sm text-brand-text-secondary hover:text-brand-text transition-colors"
            >
              首页
            </button>
            <button
              onClick={() => scrollToSection("products")}
              className="text-sm text-brand-text-secondary hover:text-brand-text transition-colors"
            >
              产品
            </button>
            <button
              onClick={() => navigate("/privacy")}
              className="text-sm text-brand-text-secondary hover:text-brand-text transition-colors"
            >
              隐私政策
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg
              className="w-6 h-6 text-brand-text"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection("hero")}
              className="block w-full text-left px-3 py-2 text-brand-text-secondary hover:text-brand-text hover:bg-gray-50 rounded-lg transition-colors"
            >
              首页
            </button>
            <button
              onClick={() => scrollToSection("products")}
              className="block w-full text-left px-3 py-2 text-brand-text-secondary hover:text-brand-text hover:bg-gray-50 rounded-lg transition-colors"
            >
              产品
            </button>
            <button
              onClick={() => {
                navigate("/privacy");
                setIsMobileMenuOpen(false);
              }}
              className="block w-full text-left px-3 py-2 text-brand-text-secondary hover:text-brand-text hover:bg-gray-50 rounded-lg transition-colors"
            >
              隐私政策
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
